<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="选择日期"
        width="1000px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="purchase"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="要求到货日期">
              <el-date-picker
                  v-model="purchase.plannedArrivalTime"
                  align="right"
                  type="date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

  export default {
    name:"UrgentTime",
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        purchase: {
          pkid: "",
          plannedArrivalTime: "",
        },
        ruleValidate: {
        },
      };
    },
    methods: {
      open(id) {
        if(id>0) {
          this.purchase.pkid = id;
        }
        this.dialogVisible = true;
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          this.submitLoading = true;
          if(valid) {
            this.$emit("save-success", this.purchase);
            this.dialogVisible = false;
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
    .el-form-item__content{
        margin-left: 2%!important;
    }
</style>
